






import {Component, Prop, Vue} from 'vue-property-decorator';
import GimmickImage from '@/components/GimmickImage.vue';
@Component({
  components: {GimmickImage},
})
export default class GimmickImageContainer extends Vue {
  @Prop({ type: Array, required: true })
  private targetList!: string[];
}
